import React from 'react';
import { Link } from 'react-router-dom';
// import Button from '@mui/material/Button';
const Hero = () => {
    return (
        <div className='hero'>
                    <div className='hero-content'>
             <h1>La primera aplicacion contra la agorafobia</h1> 
             <p className="title">Auto-terapia para superar la agorafobia</p>  
            <Link to={"/login"} >
                <div className="btn primary">
                    Iniciar Gratis
                </div>
            </Link>
            </div>
            
        </div>
    );
};

export default Hero;